var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactBlueSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 236,
    viewBox: "0 0 478 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443.555,
    height: 105.621,
    rx: 52.8105,
    transform: "matrix(0.741475 -0.67098 0.64375 0.765236 0 79.6164)",
    fill: "#C1F0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 411.598,
    height: 98.0115,
    rx: 49.0057,
    transform: "matrix(0.741475 -0.67098 0.64375 0.765236 109.715 160.587)",
    fill: "#C1F0FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBlueSvg);
export default __webpack_public_path__ + "static/media/contactBlueSvg.4aed49080d8af30f98a7fbe3efe43dbe.svg";
export { ForwardRef as ReactComponent };